"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fill: "#00579F",
      d: "M15.704 8c.752 0 1.36.151 1.744.288l-.265 1.464-.175-.072a3.615 3.615 0 0 0-1.449-.26c-.767 0-1.111.296-1.12.584 0 .317.417.526 1.097.836 1.12.483 1.64 1.075 1.632 1.846C17.152 14.092 15.824 15 13.784 15c-.872-.007-1.712-.173-2.168-.36l.272-1.522.256.108c.632.253 1.048.361 1.824.361.56 0 1.16-.21 1.168-.663 0-.296-.256-.512-1.008-.844-.736-.324-1.72-.865-1.704-1.838.008-1.32 1.36-2.242 3.28-2.242Zm-7.248 6.899H10.4l1.216-6.776H9.672l-1.216 6.776Z"
    }), (0, _jsxRuntime.jsx)("path", {
      fill: "#00579F",
      fillRule: "evenodd",
      d: "M22.432 8.123h-1.504c-.464 0-.816.122-1.016.562L17.024 14.9h2.04l.408-1.016h2.496c.056.237.232 1.016.232 1.016H24l-1.568-6.776Zm-2.4 4.376a2035.23 2035.23 0 0 0 .836-2.049c.056-.14.139-.346.196-.496l.136.584s.368 1.622.448 1.96h-1.616Z",
      clipRule: "evenodd"
    }), (0, _jsxRuntime.jsx)("path", {
      fill: "#00579F",
      d: "m4.928 12.743 1.904-4.62h2.056l-3.056 6.769H3.776L2.032 8.966c1.232.584 2.336 1.76 2.688 2.84l.208.938Z"
    }), (0, _jsxRuntime.jsx)("path", {
      fill: "#FAA61A",
      d: "M3.16 8.123H.032L0 8.26c2.44.562 4.056 1.918 4.72 3.547l-.68-3.115c-.112-.432-.456-.555-.88-.57Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};